import Helpers from "@/Helpers";
import type { SectionControlElements } from "@/sections/sectionRuntimeTypes";

const DEFAULT_PAGE_LABEL = "Page {page} of {pages}";

type PageHeaderProps = {
   testState?: { lang?: string };
   currentSection?: { pages?: number; contents?: Record<string, string> };
   page?: number;
   controlElements?: SectionControlElements;
};

export default function PageHeader(props: PageHeaderProps) {
   const { testState, currentSection, page: pageProp, controlElements } = props;
   if (!currentSection || !currentSection?.pages) return null;
   const lang = testState?.lang || "eng";
   const pages = currentSection.pages || 1;
   const page = Number(pageProp || 1);
   const content = Helpers.getSectionContent(currentSection, lang);
   const elements = Helpers.getSectionElements(content);
   let title = "";
   if (typeof elements === "object" && elements !== null) {
      title = elements?.caption || "";
   }

   const pageLabel = Helpers.pickControlText(
      controlElements?.labels?.pageLabel,
      typeof elements?.pageLabel === "string" ? elements.pageLabel : "",
      DEFAULT_PAGE_LABEL,
   ) || DEFAULT_PAGE_LABEL;
   const formattedPageLabel = pageLabel
      .replaceAll("{page}", String(page))
      .replaceAll("{pages}", String(pages));

   return (
      <div className="sectionHeader">
         <span className="heading" title={title}>{title}</span>
         {pages > 1 && (
            <span className="pages">{formattedPageLabel}</span>
         )}
      </div>
   );
}
